//original jquery
$(function () {
  let scrollPosition; // スクロール位置を保持する変数

  // モーダルボタンのクリックイベント
  $('.modal__btn').click(function(){
    const modalId = $(this).data('modal-id');
    $(`#${modalId}, #overlay`).fadeIn();
    scrollPosition = $(window).scrollTop();
    $('body').addClass('fixed').css({'top': -scrollPosition});
    $('html').addClass('fixed').css({'overflow': 'hidden', 'top': -scrollPosition});
  });
  
  // オーバーレイとクローズボタンのクリックイベント
  $('#overlay , .close__btn').click(function(){
    $('.modal-wrapper, #overlay').fadeOut();
    $('body, html').removeClass('fixed').removeAttr('style');
    window.scrollTo(0, scrollPosition);
  });
});

//1:help-index
//2:注文詳細ページのプリントボタン
//3:〃キャンセルボタン
//4:main-product カスタムメイドサウナハットの説明（shortest-date）
//5:cms HINT
//6:配送希望日
//7:配送希望時間
//8:配送リードタイム
//9:カートページアクセスポップアップモーダル
//10:翌日配送対象地域
//11:毛糸カラー案内
//12:ブログコメント欄
//13:main-cart-items 有料宅配便商品は配送日時指定は対象外です
//14:自社発送発送日
//15:main-product popup-shr-customise